/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const u=require("./fieldList.js"),e={};e.undefined=()=>{};function s(t){if(e[t])return e[t];const i=u.fieldList(t);return e[t]=function(o){let r=o;for(let n=0;n<i.length&&r;n++)r=r[i[n]];return r},e[t]}exports.getter=s;
